module.exports = __webpack_public_path__ + "static/img/Brill-Power.d5d89c00.jpg";